import { Card, FlatButton } from 'material-ui'
import React, { Component } from 'react'

class Repeater extends Component<any, any> {
  render () {
    const { value, onChange, label, newValue, resource } = this.props
    return (
      <div style={{ marginTop: 20, display: 'inline-block', width: '100%' }}>
        <h4 style={{ marginBottom: 10 }}>{label}</h4>
        {value?.map?.((v, i) => (
          <Card
            style={{
              marginLeft: 40,
              marginTop: 20,
              marginBottom: 20,
              padding: 15
            }}
            key={i}
          >
            <div
              style={{
                marginBottom: 10,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'baseline'
              }}
            >
              <this.props.component
                value={v}
                onChange={(v) =>
                  onChange(
                    null,
                    value?.map?.((existingValue, j) => {
                      if (i === j) {
                        return v
                      }
                      return existingValue
                    })
                  )
                }
                resource={resource}
              />
              <FlatButton
                style={{ marginTop: 20 }}
                secondary
                label='Remove'
                onClick={(e) =>
                  onChange(
                    e,
                    value.filter((_, j) => i !== j)
                  )
                }
              />
            </div>
          </Card>
        ))}
        <FlatButton
          onClick={(e) => {
            onChange(e, [...(value || []), newValue(this.props)])
          }}
          primary
          label='Add'
        />
      </div>
    )
  }
}

export default Repeater
